import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useParams } from "react-router-dom"
import { getScheduleRecordId } from "library/get-unique-id-from-tree.mjs"
import { getTreeId } from "routes/schedule/lib/getTreeId"
import { getRegimeScheduleComments } from "routes/schedule/plugins/share-link-comments/share-link-comments.controller"
import { isShareLinkCommentForTarget } from "routes/schedule/plugins/share-link-comments/share-link-comment-presenters"
import { isShareLinkContentOverrideEnabled } from "routes/schedule/plugins/share-link-comments/share-link-content-overrides-feature-flag"

const EMPTY = []

// Builds the auto-justification text for the current task from any share-link comments anchored to it,
// so the manual justification box can be pre-populated (the host then keeps or edits it). Returns ""
// when there are none. Feature-gated: no query when the collaboration feature is off.
export function useTaskShareLinkCommentReason() {
    const enabled = isShareLinkContentOverrideEnabled()
    const { task, schedule, schedulePath, currentId } = useBoundContext()
    const { id: routeSchedulePath } = useParams()
    const activeSchedulePath = schedulePath ?? currentId ?? routeSchedulePath
    const regimeId = enabled && activeSchedulePath ? getTreeId(activeSchedulePath) : null
    const scheduleId = enabled ? (activeSchedulePath ? getScheduleRecordId(activeSchedulePath) : schedule?.id) : null
    const comments = getRegimeScheduleComments.useResults({ regimeId, scheduleId }) ?? EMPTY

    if (!enabled || !task?.id) return ""
    return comments.filter(matches).map(toLine).join("\n")

    function matches(comment) {
        return isShareLinkCommentForTarget(comment, {
            targetType: "task",
            targetId: task.id,
            taskIndex: getTaskIndex(),
        })
    }

    function toLine(comment) {
        const name = comment.authorName ?? "a share-link reviewer"
        const date = `${comment.created ?? ""}`.slice(0, 10)
        const text = `${comment.body ?? ""}`.trim()
        return `Addressed share-link recommendation from ${name}${date ? ` on ${date}` : ""}: "${text}"`
    }

    function getTaskIndex() {
        const parsed = Number.parseInt(task?.$index ?? task?.index ?? 1, 10)
        if (Number.isNaN(parsed) || parsed < 1) return 0
        return parsed - 1
    }
}
